import React, { useState, useRef, useEffect } from 'react';

import { ControlButtonsAndDots } from './ControlButtonsAndDots';

// 1. Define the props interface
export interface ITipPagesProps {
  classOuter?: string;
  classIner?: string;
  total: number;
  titleKey: string;
  component: (index: number) => React.JSX.Element; // Any valid React children
}

export const TipPages: React.FC<ITipPagesProps> = ({ classOuter, classIner, total, component, titleKey }) => {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const ref = useRef(titleKey);

  // Get the total number of items from children
  const totalPages = total;
  useEffect(() => {
    if (ref.current !== titleKey) {
      setCurrentPage(0);
      ref.current = titleKey;
    }
  }, [titleKey]);

  const handlePrev = (): void => {
    setCurrentPage((prevPage) => {
      return Math.max(0, prevPage - 1);
    });
  };

  const handleNext = (): void => {
    setCurrentPage((prevPage) => {
      return Math.min(totalPages - 1, prevPage + 1);
    });
  };

  return (
    <div className={classOuter}>
      {/* Scrollable Container for Children */}
      <div className={classIner}>
        {/* Render children, ensuring each child has the specified itemWidth */}
        {component(currentPage)}
      </div>
      {/* Control Buttons and Dots */}
      <ControlButtonsAndDots
        currentPage={currentPage}
        totalPages={totalPages}
        handlePrev={handlePrev}
        jumpto={(index) => {
          setCurrentPage(index);
        }}
        handleNext={handleNext}
      />
    </div>
  );
};
